import * as actionTypes from '../actions/actionTypes'

const initialState = {
  downloading: false,
  recordsLoading: false,
  filterLoadingStates: [],
  success: false,
  selectRecordLoading: false,
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  selectedRecord: {},
  recordsError: null,
  modifyError: null,
  downloadError: null,
  filterError: null,
  assessorGroups: [],
  companies: [],
  orgs: [],
  empLevels: [],
  positions: [],
  positionsGroup: [],
  emps: [],
  empTypes: []
}

const fetchEmployeesStart = (state, action) => {
  return {
    ...state,
    recordsLoading: true,
    selectRecordLoading: true,
    error: null
  }
}

const fetchEmployeesSuccess = (state, action) => {
  return {
    ...state,
    records: action.records,
    pagination: action.pagination,
    recordsLoading: false,
    selectRecordLoading: false
  }
}

const fetchEmployeeByIdSuccess = (state, action) => {
  return {
    ...state,
    selectedRecord: action.recordData,
    selectRecordLoading: false,
    recordsLoading: false
  }
}

const fetchEmployeesFailed = (state, action) => {
  return {
    ...state,
    recordsLoading: false,
    selectRecordLoading: false
  }
}

const clearSelectedEmployeeRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: {},
    success: false
  }
}

// create
const createEmployeeStart = (state, action) => {
  return {
    ...state,
    selectRecordLoading: true,
    modifyError: null
  }
}

const createEmployeeSuccess = (state, action) => {
  return {
    ...state,
    selectRecordLoading: false,
    modifySuccess: true,
    modifyError: null,
    success: true
  }
}

const createEmployeeFailed = (state, action) => {
  return {
    ...state,
    selectRecordLoading: false,
    modifyError: action.errorMessage,
    modifySuccess: false,
    success: false
  }
}

// update
const updateEmployeeStart = (state, action) => {
  return {
    ...state,
    selectRecordLoading: true,
    modifyError: null
  }
}

const updateEmployeeSuccess = (state, action) => {
  return {
    ...state,
    success: true,
    selectRecordLoading: false,
    modifySuccess: true,
    modifyError: null
  }
}

const updateEmployeeFailed = (state, action) => {
  return {
    ...state,
    selectRecordLoading: false,
    modifyError: action.errorMessage,
    modifySuccess: false,
    success: false
  }
}

// delete (bulk)
const deleteEmployeesStart = (state, action) => {
  return {
    ...state,
    recordsLoading: true
  }
}

// This method won't stop loading since it will stopped by fetch emps.
// If we stop loading here it will make it stop loading and load again by fetch emps.
// But actully we don't need this method since it returns the same states.
const deleteEmployeesSuccess = (state, action) => {
  return {
    ...state,
    success: true
  }
}

const deleteEmployeesFailed = (state, action) => {
  return {
    ...state,
    recordsLoading: false,
    recordsError: action.errorMessage,
    success: false
  }
}

// import without (importEmployeesSuccess). Reason? scroll up a bit.
const importEmployeesStart = (state, action) => {
  return {
    ...state,
    recordsLoading: true
  }
}

const importEmployeesFailed = (state, action) => {
  return {
    ...state,
    recordsLoading: false,
    recordsError: action.errorMessage
  }
}

// Export and Download are the same because it doesn't update any UI
// except showing/stopping download spinner to show that their request are processing
const exportAndDownloadEmployeesStart = (state, action) => {
  return {
    ...state,
    downloading: true
  }
}

const exportAndDownloadEmployeesSuccess = (state, action) => {
  return {
    ...state,
    downloading: false
  }
}

const exportAndDownloadEmployeesFailed = (state, action) => {
  return {
    ...state,
    downloading: false,
    downloadError: action.errorMessage
  }
}

const fetchOptionsStart = (state, action, filterKey) => {
  return {
    ...state,
    filterLoadingStates: [...state.filterLoadingStates, filterKey]
  }
}
const fetchCompanyOptionsSuccess = (state, action) => {
  return {
    ...state,
    companies: action.data,
    filterLoadingStates: state.filterLoadingStates.filter(item => item !== 'company_id')
  }
}
const fetchOrgSuccess = (state, action) => {
  return {
    ...state,
    orgs: action.data,
    filterLoadingStates: state.filterLoadingStates.filter(item => item !== 'org_id')
  }
}
const fetchEmpLevelSuccess = (state, action) => {
  return {
    ...state,
    empLevels: action.data,
    filterLoadingStates: state.filterLoadingStates.filter(item => item !== 'level_id')
  }
}
const fetchPositionSuccess = (state, action) => {
  return {
    ...state,
    positions: action.data,
    filterLoadingStates: state.filterLoadingStates.filter(item => item !== 'position_id')
  }
}
const fetchPositionGroupSuccess = (state, action) => {
  return {
    ...state,
    positionsGroup: action.data,
    filterLoadingStates: state.filterLoadingStates.filter(item => item !== 'position_group_id')
  }
}
const fetchEmpSuccess = (state, action) => {
  return {
    ...state,
    emps: action.data,
    filterLoadingStates: state.filterLoadingStates.filter(item => item !== 'emp_id')
  }
}

const fetchAssessorGroupOptionsSuccess = (state, action) => {
  return {
    ...state,
    assessorGroups: action.data,
    filterLoadingStates: state.filterLoadingStates.filter(item => item !== 'assessor_group_id')
  }
}

const fetchEmpTypeOptionsSuccess = (state, action) => {
  return {
    ...state,
    empTypes: action.data,
    filterLoadingStates: state.filterLoadingStates.filter(item => item !== 'emp_type_id')
  }
}

const fetchOptionsFailed = (state, action, filterKey) => {
  return {
    ...state,
    filterLoadingStates: state.filterLoadingStates.filter(item => item !== filterKey),
    filterError: action.errorMessage
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_EMPLOYEE_START:
      return fetchEmployeesStart(state, action)
    case actionTypes.FETCH_EMPLOYEE_SUCCESS:
      return fetchEmployeesSuccess(state, action)
    case actionTypes.FETCH_EMPLOYEE_BY_ID_SUCCESS:
      return fetchEmployeeByIdSuccess(state, action)
    case actionTypes.FETCH_EMPLOYEE_FAILED:
      return fetchEmployeesFailed(state, action)
    case actionTypes.CREATE_EMPLOYEE_START:
      return createEmployeeStart(state, action)
    case actionTypes.CREATE_EMPLOYEE_SUCCESS:
      return createEmployeeSuccess(state, action)
    case actionTypes.CREATE_EMPLOYEE_FAILED:
      return createEmployeeFailed(state, action)
    case actionTypes.UPDATE_EMPLOYEE_START:
      return updateEmployeeStart(state, action)
    case actionTypes.UPDATE_EMPLOYEE_SUCCESS:
      return updateEmployeeSuccess(state, action)
    case actionTypes.UPDATE_EMPLOYEE_FAILED:
      return updateEmployeeFailed(state, action)
    case actionTypes.DELETE_EMPLOYEE_START:
      return deleteEmployeesStart(state, action)
    case actionTypes.DELETE_EMPLOYEE_SUCCESS:
      return deleteEmployeesSuccess(state, action)
    case actionTypes.DELETE_EMPLOYEE_FAILED:
      return deleteEmployeesFailed(state, action)
    case actionTypes.IMPORT_EMPLOYEE_START:
      return importEmployeesStart(state, action)
    case actionTypes.IMPORT_EMPLOYEE_FAILED:
      return importEmployeesFailed(state, action)
    case actionTypes.CLEAR_SELECTED_EMPLOYEE_RECORD:
      return clearSelectedEmployeeRecord(state, action)
    case actionTypes.EXPORT_EMPLOYEE_START:
    case actionTypes.DOWNLOAD_EMPLOYEE_TEMPLATE_START:
      return exportAndDownloadEmployeesStart(state, action)
    case actionTypes.EXPORT_EMPLOYEE_SUCCESS:
    case actionTypes.DOWNLOAD_EMPLOYEE_TEMPLATE_SUCCESS:
      return exportAndDownloadEmployeesSuccess(state, action)
    case actionTypes.EXPORT_EMPLOYEE_FAILED:
    case actionTypes.DOWNLOAD_EMPLOYEE_TEMPLATE_FAILED:
      return exportAndDownloadEmployeesFailed(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_EMPLOYEE_START:
      return fetchOptionsStart(state, action, 'org_id')
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_START:
      return fetchOptionsStart(state, action, 'org_id')
    case actionTypes.FETCH_EMPLOYEE_LEVEL_OPTIONS_START:
      return fetchOptionsStart(state, action, 'level_id')
    case actionTypes.FETCH_POSITION_OPTIONS_START:
      return fetchOptionsStart(state, action, 'position_id')
    case actionTypes.FETCH_EMPLOYEE_OPTIONS_START:
      return fetchOptionsStart(state, action, 'emp_id')
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchOptionsStart(state, action, 'company_id')
    case actionTypes.FETCH_ASSESSOR_GROUP_OPTIONS_START:
      return fetchOptionsStart(state, action, 'assessor_group_id')
    case actionTypes.FETCH_EMPLOYEE_TYPE_OPTIONS_START:
      return fetchOptionsStart(state, action, 'emp_type_id')
    case actionTypes.FETCH_POSITION_GROUP_OPTIONS_START:
      return fetchOptionsStart(state, action, 'position_group_id')
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanyOptionsSuccess(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_EMPLOYEE_SUCCESS:
      return fetchOrgSuccess(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_SUCCESS:
      return fetchOrgSuccess(state, action)
    case actionTypes.FETCH_EMPLOYEE_LEVEL_OPTIONS_SUCCESS:
      return fetchEmpLevelSuccess(state, action)
    case actionTypes.FETCH_POSITION_OPTIONS_SUCCESS:
      return fetchPositionSuccess(state, action)
    case actionTypes.FETCH_POSITION_GROUP_OPTIONS_SUCCESS:
      return fetchPositionGroupSuccess(state, action)
    case actionTypes.FETCH_EMPLOYEE_OPTIONS_SUCCESS:
      return fetchEmpSuccess(state, action)
    case actionTypes.FETCH_ASSESSOR_GROUP_OPTIONS_SUCCESS:
      return fetchAssessorGroupOptionsSuccess(state, action)
    case actionTypes.FETCH_EMPLOYEE_TYPE_OPTIONS_SUCCESS:
      return fetchEmpTypeOptionsSuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchOptionsFailed(state, action, 'company_id')
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_EMPLOYEE_FAILED:
      return fetchOptionsFailed(state, action, 'org_id')
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FAILED:
      return fetchOptionsFailed(state, action, 'org_id')
    case actionTypes.FETCH_EMPLOYEE_LEVEL_OPTIONS_FAILED:
      return fetchOptionsFailed(state, action, 'level_id')
    case actionTypes.FETCH_POSITION_OPTIONS_FAILED:
      return fetchOptionsFailed(state, action, 'position_id')
    case actionTypes.FETCH_EMPLOYEE_OPTIONS_FAILED:
      return fetchOptionsFailed(state, action, 'emp_id')
    case actionTypes.FETCH_ASSESSOR_GROUP_OPTIONS_FAILED:
      return fetchOptionsFailed(state, action, 'assessor_group_id')
    case actionTypes.FETCH_EMPLOYEE_TYPE_OPTIONS_FAILED:
      return fetchOptionsFailed(state, action, 'emp_type_id')
    case actionTypes.FETCH_POSITION_GROUP_OPTIONS_FAILED:
      return fetchOptionsFailed(state, action, 'position_group_id')
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
